<template lang="html">
  <div>
    <div class="row">
      <div class="col-md-12">
        <f7-searchbar class="search"
        cancel-link="Cancel"
        placeholder="Search in Drafts"
        search-list="#draft-list"
        @searchbar:search="onSearch"
        @searchbar:clear="onClear">
        </f7-searchbar>
      </div>
    </div>
    <div class="layoutSubtitle"/>
    <cm-draft-list :filterBy="filterBy" :drafts="drafts"></cm-draft-list>
  </div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import DraftList from '../CMDraftList.vue'
import moment from 'moment'

export default {
  name: 'drafts-rtp',
  components: {
    'cm-draft-list': DraftList
  },
  data: () => {
    return {
      drafts: [],
      draftsSelected: [],
      filterBy: ''
    }
  },
  created () {
    // Initialisation de paramètres
    this.$f7.params.swipePanel = this.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = this.$engine.services.directPayments.filter.smartphoneStorage
  },
  mounted () {
    // Initialisation des drafts
    this.refreshDrafts()
  },
  methods: {
    /** Rafraichissment des brouillons */
    refreshDrafts () {
      let that = this
      let params = {
        idAccount: this.$engine.user.get().id
      }
      this.$engine.drafts.getDrafts(params).then(response => {
        that.status = response.status
        if (response.status === 200) {
          this.updateDrafts(response.data.drafts)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },

    /**
    * Remplacement des brouillons en mémoire par les brouillons en paramètre
    * @param {Array} drafts - Liste des brouillons à afficher
    */
    updateDrafts (drafts) {
      this.drafts = drafts
    },

    /** Extraction CSV des brouillons */
    extractCSV () {
      let drafts = this.drafts
      let firstLine = 'draftName;Status\r\n'
      let lines = ''
      for (let datas in drafts) {
        lines += drafts[datas]['draftName'] + ';'
        var status = DraftList.methods.getLabelStatus(drafts[datas])
        lines += status + '\r\n'
      }

      let data = firstLine + lines
      let today = moment()
      const linkSource = 'data:text/csv;charset:utf-8,' + data
      const downloadLink = document.createElement('a')
      const fileName = 'draftRequestToPay' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },

    /**
    * Fonction appelée lorsque l'utilisateur veut faire une recherche
    * @event
    */
    onSearch: function (query, found) {
      this.filterBy = query
    },

    /**
    * Fonction appelée lorsque le filtre doit être purgé
    * @event
    */
    onClear: function () {
      this.filterBy = ''
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Drafts.vue?0e1a4058